import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private http: HttpClient) { }

  getTeams(body: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/Team/GetTeams', body).pipe(map((response: any) => {
      return response
    }));
  }

  getUserByEmail(clientId: any, searchText: any): Observable<any> {
    let body = {
      clientId: clientId,
      searchText: searchText
    };

    return this.http.post(environment.WebApiURL + 'api/Team/GetUserByEmail', body).pipe(map((response: any) => {
      return response
    }));
  }

  addTeamMember(stTeamMemberId: any, teamId: any, uiLoggedInUserId: any,deselectedUserIds:any): Observable<any> {
    let body = {
      stTeamMemberId: stTeamMemberId,
      uiTeamId: teamId,
      uiUserId: uiLoggedInUserId,
      deselectedUserIds: deselectedUserIds
    };

    return this.http.post(environment.WebApiURL + 'api/Team/AddTeamMember', body).pipe(map((response: any) => {
      return response
    }));
  }

  addTeam(data: any): Observable<any> {
    let body = {
      teamId: data.teamId,
      clientId: data.clientId,
      name: data.name,
      email: data.email,
      teamMember: data.teamMember,
      flgtpa : data.TPA,
      flgIsEmailOnPublish: data.flgIsEmailOnPublish,
      faxnumber: data.faxnumber,
      reportEmail: data.reportEmail,
      address: data.address,
      inReportType:data.inReportType,
      inPriority:data.inPriority,
      inTurnaroundTime:data.inTurnaroundTime,
      stReportTypes:data.stReportTypes
    };

    return this.http.post(environment.WebApiURL + 'api/Team/Manage', body).pipe(map((response: any) => {
      return response
    }));
  }

  removeTeamMember(userId: any, teamId: any): Observable<any> {
    let body = {
      userId: userId,
      teamId: teamId
    };

    return this.http.post(environment.WebApiURL + 'api/Team/RemoveTeamMember', body).pipe(map((response: any) => {
      return response
    }));
  }

  archiveTeam(teamId: any): Observable<any> {
    const body = {
      teamId: teamId
    }
    return this.http.post(environment.WebApiURL + 'api/Team/Archive', body).pipe(map((response: any) => {
      return response
    }));
  }

  getteamByTeamId(data: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/Team/GetTeamById', data).pipe(map((response: any) => {
      return response
    }));
  }
  private refreshTeams = new Subject<void>();
  refreshTeams$ = this.refreshTeams.asObservable();
  RefreshTeams(){
    this.refreshTeams.next();
  }
}
